module.exports = __webpack_public_path__ + "media/images/task-icon-hover-f477e1baffbd791daf986d50bf85f1f0.svg";